export default __webpack_public_path__ + "static/media/report-quality-inspection.24652cc6.svg";